<div class="page_404_container">
  <div class="img_container">
      <img ngSrc="/assets/main/page-not-found.png" height="200" width="290" class="page_not_found_image" alt="Page not found">
  </div>
  <div class="page_not_found_label">
    <h1>404 - Page Not Found</h1>
  </div>
  <div class="page_not_found_message">
    <p i18n>The page you are looking for doesn't exist or has been moved.</p>
  </div>
  <div class="action_container">
    <button type="button" class="go_back_button primary-black-btn" (click)="goBack()" i18n>Go Back</button>
  </div>
</div>
